import { setTheme } from './index'

export const themes = {
  light: {
    name: 'LIGHT', bg: '#FAFAFA', bgElevated: '#FFFFFF', bgSidebar: '#FFFFFF',
    text: '#0A0A0A', textSecondary: '#555555', textMuted: '#999999',
    border: '#E8E8E8', borderStrong: '#D0D0D0',
    primary: '#00F5D4', primaryDim: 'rgba(0,245,212,0.08)',
    accent: '#7B2FFF', accentDim: 'rgba(123,47,255,0.08)',
    cardBg: '#FFFFFF', sidebarBg: '#FFFFFF', topbarBg: 'rgba(255,255,255,0.95)',
    inputBg: '#F5F5F5', hoverBg: 'rgba(0,245,212,0.05)',
    navActiveBg: 'rgba(0,245,212,0.10)', navActiveBorder: '#00F5D4',
    shadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  },
  dark: {
    name: 'DARK', bg: '#0A0A0A', bgElevated: '#141414', bgSidebar: '#0E0E0E',
    text: '#FAFAFA', textSecondary: '#A0A0A0', textMuted: '#606060',
    border: '#2A2A2A', borderStrong: '#3A3A3A',
    primary: '#00F5D4', primaryDim: 'rgba(0,245,212,0.12)',
    accent: '#A855F7', accentDim: 'rgba(168,85,247,0.12)',
    cardBg: '#141414', sidebarBg: '#0E0E0E', topbarBg: 'rgba(14,14,14,0.95)',
    inputBg: '#1A1A1A', hoverBg: 'rgba(0,245,212,0.08)',
    navActiveBg: 'rgba(0,245,212,0.12)', navActiveBorder: '#00F5D4',
    shadow: '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.2)',
  },
}

export type ThemeName = 'light' | 'dark'
export type ThemeVars = typeof themes.light

export function getVars(theme: ThemeName): ThemeVars {
  return themes[theme]
}

export function toggleTheme() {
  const next = (localStorage.getItem('teslacam_theme') === 'dark') ? 'light' : 'dark'
  setTheme(next)
}
